import React, { Component } from 'react'
import { createMuiTheme, MuiThemeProvider } from 'material-ui/styles'
import { Page } from './Layout'
import { DialogLogIn, DialogRegister } from './Dialogs'
import { red } from 'material-ui/colors'
import DialogAlert from './Dialogs/DialogAlert'
import { withCookies } from 'react-cookie'

{/* 37b799 */}

const theme = createMuiTheme({
  palette: {
    primary: { 500: '#32a087' },
    secondary: red,
  },
  status: {
    danger: red[600],
  },
  overrides: {
    MuiInput: {
      underline: {
        color: red,
        '&:hover:not($disabled):after': {
          backgroundColor: red,
        },
        '&:hover:not($disabled):before': {
          backgroundColor: red,
        },
      },
    },
  },
});

class App extends Component {
  state = {
      main_open: false,
      dialog_login_open: true,
      dialog_register_open: false,
      alert_open: false,
      acc_data: null,
  };

  openMain = (acc_data) => {
    this.setState({
      dialog_register_open: false,
      dialog_login_open: false,
      main_open: true,
      acc_data: acc_data,
    });
  }

  openLogInDialog = () => {
    this.setState({
      main_open: false,
      dialog_register_open: false,
      dialog_login_open: true
    });
  }

  openRegisterDialog = () => {
    this.setState({
      main_open: false,
      dialog_login_open: false,
      dialog_register_open: true
    });
  }

  openAlert = (title, message) => {
    this.setState({
      alert_title: title,
      alert_message: message,
      alert_open: true
    });
  }

  closeAlert = () => {
    this.setState({
      alert_open: false
    });
  }

  render() {
    return <MuiThemeProvider theme={theme}>
      {this.state.main_open && <Page accData={this.state.acc_data} onLogOut={this.openLogInDialog} />}
      <DialogLogIn open={this.state.dialog_login_open} onRegister={this.openRegisterDialog} onLogIn={this.openMain} onAlertOpen={this.openAlert} />
      <DialogRegister open={this.state.dialog_register_open} onBack={this.openLogInDialog} onRegister={this.openMain} onAlertOpen={this.openAlert} />
      <DialogAlert open={this.state.alert_open} onClose={this.closeAlert} title={this.state.alert_title} message={this.state.alert_message} />
    </MuiThemeProvider>
  }
}

export default withCookies(App)



// WEBPACK FOOTER //
// ./src/Components/App.js